'use strict';

var chunkLJTDKDRA_js = require('./chunk-LJTDKDRA.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var react = require('react');
var i = require('clsx');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var i__default = /*#__PURE__*/_interopDefault(i);

var v=({label:s,description:e,id:r,value:m,onChange:c,placeholder:d,fullWidth:p,width:f,rows:g,error:a,textAreaRef:h,className:x,...A})=>{let b=`${chunk32OAM7MJ_js.a}-textarea`,u=i__default.default(b,x,{"full-width":p,"with-description":!!e}),o=react.useId();return jsxRuntime.jsxs("div",{className:u,style:{width:f},children:[s&&jsxRuntime.jsx("label",{className:"label",htmlFor:r,children:s}),e&&jsxRuntime.jsx("div",{className:"description",id:`${r}-description`,children:typeof e=="string"?jsxRuntime.jsx("p",{children:e}):e}),jsxRuntime.jsx("textarea",{className:i__default.default("textarea",{error:a}),ref:h,name:r,id:r,value:m||"",placeholder:d,onChange:c,"aria-describedby":a&&o,rows:g,...A}),a&&jsxRuntime.jsx(chunkLJTDKDRA_js.a,{errorMessage:a,errorId:o})]})},N=v;

exports.a = N;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-DJQYWSSY.js.map